import * as constants from './Transcript.constants';
import * as services from './Transcript.service';

const state = {
  isRequest: false,
  transcript: {},
};

const mutations = {
  [constants.GET_PZ_MOCK_PAPER_RESULT_SUCCESS](state, transcript) {
    if (null !== transcript && undefined !== transcript) {
      state.transcript = transcript;
    }
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getPzMockPaperResult({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const params = services.getPzMockPaperResult(payload);
    const res = await params;
    if (200 === res.data.status) {
      commit(constants.GET_PZ_MOCK_PAPER_RESULT_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
    return params;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
